import angular from 'angular';
import socialSecurityListComponent from './socialSecurityList.component';

let socialSecurityListModule = angular.module('socialSecurityList', [
])

.component('socialSecurityList', socialSecurityListComponent)

.name;

export default socialSecurityListModule;



// WEBPACK FOOTER //
// ./client/app/social-security.module/features/socialSecurity/socialSecurityList/socialSecurityList.js